import { TFactoryState } from '@monorepo/types';
import { ActionReducer } from '@ngrx/store';
import { TFactoryActions } from './factory.actions';

export const initialState: TFactoryState = {
  factoryInfo: undefined,
  selectedNodeInfo: null,
  nodeLoading: {
    status: true,
  },
};

export const factoryReducer: ActionReducer<TFactoryState, TFactoryActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZE_FACTORY':
      return { ...state, factoryInfo: action.payload && { ...action.payload } };
    case 'SELECT_ORG_TREE_NODE':
      return { ...state, selectedNodeInfo: action.payload, nodeLoading: { status: false } };
    case 'ORG_TREE_NODE_LOADING':
      return { ...state, nodeLoading: { status: true, title: action.title } };
    case 'ORG_TREE_NODE_LOADED':
      return { ...state, nodeLoading: { status: false } };
    default:
      return state;
  }
};
